export const ASSISTANT_IDES = {
  program_finder: 'asst_xWnF9XgI2mum5uq9Y6595B2g',
  behavior_finder: 'asst_YcUZnCsyRigOSRYLf5oxlJOr',
  behavior_attributes: 'asst_5HYWBqB4IXHvxC7KZlww3NYt',
  behavior_prompt: 'asst_lm0CRiPYYqT8yCMy26g0sWcG',
}
